<template>
<v-card class="mt-2">
  <v-card-title>提供サービス</v-card-title>
  <v-data-table :headers="headers" :items="company.services" :pagination.sync="pagination" :rows-per-page-items="[10]" class="inline-edit" item-key="type">
    <template slot="items" slot-scope="props">
      <!-- <td>
          <v-checkbox hide-details primary v-model="props.selected"></v-checkbox>
        </td>-->
      <td>{{ serviceMapping(props.item.type) }}</td>
      <td>
        <date-picker v-model="props.item.startDate"></date-picker>
      </td>
      <td>
        <date-picker :min="props.item.startDate" v-model="props.item.endDate"></date-picker>
      </td>
      <td>
        <v-text-field clearable label v-model="props.item.contact"></v-text-field>
      </td>
      <td>
        <v-text-field clearable label v-model="props.item.tel"></v-text-field>
      </td>
      <td>
        <v-text-field clearable label v-model="props.item.email"></v-text-field>
      </td>
    </template>
  </v-data-table>
</v-card>
</template>

<script>
export default {
  props: ['company'],
  data() {
    return {
      headers: [{
          text: 'サービス名',
          value: 'type',
          sortable: false
        },
        {
          text: '適用約開始日',
          value: 'startDate',
          sortable: false
        },
        {
          text: '適用終了日',
          value: 'endDate',
          sortable: false
        },
        {
          text: '業務連絡先担当',
          value: 'contacter',
          sortable: false
        },
        {
          text: '連絡先電話',
          value: 'phone',
          sortable: false
        },
        {
          text: '連絡先メールアドレス',
          value: 'email',
          sortable: false
        }
      ],
      pagination: {
        rowsPerPage: 10,
        page: 1
      }
    }
  },
  methods: {
    load() {},
    serviceMapping(val) {
      var services = {
        DRAKE: 'ドレージ',
        CHARTER: 'チャーター',
        MIXLOADING: '混載',
        DEVAN: 'デバン',
        CUSTOMS_CLEARANCE: '通関',
        FORWARDER: 'フォワダー'
      }
      return services[val]
    }
  },
  mounted() {
    this.load()
  }
}
</script>
